module.exports = __webpack_public_path__ + "static/media/ic-twitter.654a39b2.svg";